import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@chakra-ui/react';
import Checkbox from '../../shared/Checkbox';
import styles from './LoginForm.scss';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      keepSignedIn: false,
      showPassword: false,
    };

    this.onEmailChange = this.onEmailChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onKeepSignedInChange = this.onKeepSignedInChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onShowPasswordClick = this.onShowPasswordClick.bind(this);
  }

  onEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  onPasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  onKeepSignedInChange(value) {
    this.setState({ keepSignedIn: value });
  }

  onShowPasswordClick() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }

  handleSubmit(event) {
    event.preventDefault();
    const { email, password, keepSignedIn } = this.state;
    const { onSubmit } = this.props;

    onSubmit(email, password, keepSignedIn);
  }

  renderErrorMessage() {
    const { errorMessage } = this.props;
    return errorMessage ? <p className={styles.error}>{errorMessage}</p> : null;
  }

  renderSettings() {
    const { keepSignedIn } = this.state;
    return (
      <div className={styles.loginSettings}>
        <span
          onClick={() => {
            this.onKeepSignedInChange(!keepSignedIn);
          }}
          className={`${keepSignedIn ? '' : styles.inactive}`}
          style={{ color: '#A0A9B7', fontWeight: 700 }}
        >
          Keep me signed in:
        </span>
        <Checkbox checked={keepSignedIn} onChange={this.onKeepSignedInChange} />
      </div>
    );
  }

  renderSubmitButton() {
    const { isLoading } = this.props;
    const { email, password } = this.state;
    return (
      <Button
        colorScheme={'red'}
        isLoading={isLoading}
        disabled={!(email && password)}
        type="submit"
        bgColor={'#AA1E2F'}
        w={'100%'}
      >
        Sign In
      </Button>
    );
  }

  render() {
    const { email, password, showPassword } = this.state;

    return (
      <form className={styles.loginForm} onSubmit={this.handleSubmit}>
        <div className="form-group input-group">
          <div className="input-group-prepend">
            <div className="input-group-text">
              <i className="fa fa-envelope" />
            </div>
          </div>
          <input
            required
            type="email"
            className="form-control"
            placeholder="Email"
            value={email}
            onChange={this.onEmailChange}
          />
        </div>

        <div className="form-group input-group">
          <div className="input-group-prepend" onClick={this.onShowPasswordClick}>
            <div className="input-group-text">
              <i className={`${styles.passwordIcon} fa fa-eye${showPassword ? '' : '-slash'}`} />
            </div>
          </div>
          <input
            required
            type={showPassword ? 'input' : 'password'}
            className="form-control"
            placeholder="Password"
            value={password}
            onChange={this.onPasswordChange}
          />
        </div>

        {this.renderSubmitButton()}
        {this.renderErrorMessage()}
        {this.renderSettings()}
      </form>
    );
  }
}

LoginForm.propTypes = {
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

export default LoginForm;



// WEBPACK FOOTER //
// src/components/login/LoginForm/LoginForm.js